// src/pages/Studio.js
// Embeds the KarviAI Studio editor (a separate service, kept independent for
// licensing reasons — see kimu-editor's LICENSE) inside Karvi via an <iframe>,
// so it feels like part of this site rather than a separate destination.
// Auth is handed off through the SSO bridge (Studio's /sso route): we pass
// the user's existing Karvi token, Studio verifies it against Karvi's own
// /auth/me and signs them in automatically — no second login screen.

import { getToken } from "../api";

const STUDIO_URL = process.env.REACT_APP_STUDIO_URL || "";

export default function Studio({ returnPath }) {
  let src = `${STUDIO_URL}/sso?token=${encodeURIComponent(getToken() || "")}`;
  if (returnPath) src += `&returnTo=${encodeURIComponent(returnPath)}`;

  return (
    <div className="studio-embed">
      <iframe
        src={src}
        title="KarviAI Studio"
        className="studio-embed__frame"
        allow="clipboard-write; fullscreen"
      />
    </div>
  );
}
